import { Box } from '@mui/material';
import MediaEntetiesTable from '../../../common/MediaEntitiesTable';

const RubikaTable = () => {
	return (
		<Box className="w-full">
			<MediaEntetiesTable media_id={3} />
		</Box>
	);
};

export default RubikaTable;
